import { DOMAIN_TYPE } from '../constants';

const DOMAIN_NAME = 'user';

export const SET_TOKEN = `${DOMAIN_TYPE}/${DOMAIN_NAME}/SET_TOKEN` as const;

// The path the user was originally trying to reach when auth bounced them.
// Set when an OIDC roundtrip carries `state.redirectTo` back to /signin-oidc;
// consumed (and cleared) by SigninOidcPage so that the user lands on their
// intended page instead of START_PAGE.
export const SET_POST_LOGIN_REDIRECT =
  `${DOMAIN_TYPE}/${DOMAIN_NAME}/SET_POST_LOGIN_REDIRECT` as const;

export const START_LOGIN = `${DOMAIN_TYPE}/${DOMAIN_NAME}/START_LOGIN` as const;

export const START_LOGOUT =
  `${DOMAIN_TYPE}/${DOMAIN_NAME}/START_LOGOUT` as const;

export const START_VERIFY =
  `${DOMAIN_TYPE}/${DOMAIN_NAME}/START_VERIFY` as const;
